"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "15px",
    height: "23px",
    viewBox: "0 0 15 23"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,2.396 C0,1.073 1.079,0 2.393,0 L12.607,0 C13.928,0 15,1.078 15,2.396 L15,20.603 C15,21.927 13.921,23 12.607,23 L2.393,23 C1.072,23 0,21.921 0,20.603 L0,2.396 L0,2.396 Z M7.5,20.62 C8.154,20.62 8.684,20.088 8.684,19.431 C8.684,18.774 8.154,18.241 7.5,18.241 C6.846,18.241 6.316,18.774 6.316,19.431 C6.316,20.088 6.846,20.62 7.5,20.62 L7.5,20.62 L7.5,20.62 Z M2,16 L13,16 L13,2 L2,2 L2,16 L2,16 Z"
  })));
};

exports["default"] = _default;